import { forwardRef, Ref, useEffect, useImperativeHandle, useRef } from "react";

import colors from "@app/styles/_colors.module.scss";

interface Props extends google.maps.CircleOptions {
  fitBounds?: boolean;
}

const Circle = ({ fitBounds, map, ...props }: Props, ref: Ref<google.maps.Circle | null>) => {
  const circle = useRef<google.maps.Circle | null>(null);

  useEffect(
    () => {
      if (!map) {
        return;
      }

      circle.current = new google.maps.Circle({
        editable: false,
        fillColor: colors.red100,
        fillOpacity: 0.2,
        strokeColor: colors.red100,
        strokeWeight: 2,
        ...props,
        map,
      });

      if (fitBounds) {
        const bounds = circle.current.getBounds()!;
        map.fitBounds(bounds, 32);
      }

      return () => {
        circle.current?.setMap(null);
      };
    },
    // ignoring because we listed all possible props
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      fitBounds,
      map,
      props.center,
      props.clickable,
      props.draggable,
      props.editable,
      props.fillColor,
      props.fillOpacity,
      props.radius,
      props.strokeColor,
      props.strokeOpacity,
      props.strokePosition,
      props.strokeWeight,
      props.visible,
      props.zIndex,
    ]
  );

  useImperativeHandle(ref, () => circle.current);

  return null;
};

export default forwardRef(Circle);
